import React from "react";

export const Tooltip = ({ error, onChipClick, onIgnoreClick }) => {
  return (
    <div className="spell-checker-tooltip">
      <div className="spell-checker-tooltip__surface spell-checker-tooltip__surface_body">
        <div
          className={`spell-checker-tooltip__title spell-checker-tooltip__title_${error.ui.tag}`}
        >
          {error.ui.title}
        </div>
        <div className="spell-checker-tooltip__description">
          {error.ui.description}
        </div>
        {error?.s && error.s.length !== 0 && (
          <div className="spell-checker-tooltip__chips">
            {error.s.map((s, index) => (
              <span
                className="spell-checker-tooltip__chip"
                onClick={onChipClick(s)}
                key={index}
              >
                {s}
              </span>
            ))}
          </div>
        )}
      </div>
      {}
      <div className="spell-checker-tooltip__surface spell-checker-tooltip__surface_footer">
        <button
          className="spell-checker-tooltip__button"
          onClick={onIgnoreClick}
        >
          <span className="spell-checker-tooltip__button-text">
            Игнорировать ошибку
          </span>
        </button>
      </div>
    </div>
  );
};
